import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_2 = { class: "w-100 text-start" }
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = { class: "text-color-darkgray" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger show",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-danger show",
  role: "alert"
}
const _hoisted_7 = {
  id: "uploadDetailsInfo",
  class: "inline-flex"
}
const _hoisted_8 = { class: "val" }
const _hoisted_9 = { class: "val" }
const _hoisted_10 = { class: "val" }
const _hoisted_11 = { class: "val" }
const _hoisted_12 = {
  key: 0,
  class: "table-responsive mb-3"
}
const _hoisted_13 = {
  style: {"width":"70px","text-align":"end"},
  class: "mb-0 d-inline-block"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  style: {"overflow":"initial"}
}
const _hoisted_16 = { class: "" }
const _hoisted_17 = {
  key: 0,
  class: "filter-description"
}
const _hoisted_18 = {
  key: 0,
  class: "btn-group ms-auto",
  style: {},
  role: "group"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "mt-2 position-relative" }
const _hoisted_24 = {
  key: 1,
  class: "filter-description"
}
const _hoisted_25 = {
  key: 0,
  class: "btn-group ms-auto",
  role: "group"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 0,
  class: "btn-group",
  role: "group"
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["href"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "container-fluid"
}

import { AxiosResponse } from "axios";
import { computed, defineComponent, ref, watch } from "vue";
import {
    UploadedFileDetails,
    UploadedFileWarningsAndErrors,
    FileStatistics,
    FailedFileDetails,
} from "../types";

import BTable from "./BTable/BTable.vue";
import BTableHeader from "./BTable/BTableHeader.vue";
import { BTableOptions, BTableColumn } from "./BTable/BTable.types";
import { serializeFilters, serializeSortBy } from "./BTable/HelperFunctions";
import BFilterEditor from "./BFilterEditor/BFilterEditor.vue";
import BFilterModal from "./BFilterEditor/BFilterModal.vue";
import InformationModal from "./Misc/InformationModal.vue";

import {
    BFilterOptions,
    BFilter,
    BFilterableField,
    BFieldSelection,
    describeFilters,
} from "./BFilterEditor/BFilterEditor.types";
import { useCommunityPolicingStore } from "@/stores/communityPolicingStore";
import { useContactsStore } from "@/stores/contactsStore";
import { useNibrsStore } from "@/stores/nibrsStore";
import { useUofStore } from "@/stores/uofStore";
import { useSummaryStore } from "@/stores/summaryStore";
import { UploadType } from "@/types";
import { useNarrativeStore } from "@/stores/narrativeStore";
import { usePoliceEmployeeStore } from "@/stores/policeEmployeeStore";
import { usePopulationStore } from "@/stores/populationStore";
import { getHtmlContent } from '@/utils';
import {validationMessagesFilterableFields} from '@/tableDefaults';
import DropDown from "@/components/Misc/DropDown.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DataUploadDetails',
  props: {
    name: {},
    url: {},
    id: {},
    onlyHasOneOri: { type: Boolean },
    dataset: {},
    enableLinkToEditor: { type: Boolean },
    editorLink: {},
    exportUrl: {},
    descriptionUrl: {},
    noTotal: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
var store = {} as any;
    var uploadType: UploadType = UploadType[props.dataset ?? ""];

    switch (uploadType) {
        case UploadType.contacts:
            store = useContactsStore();
            break;
        case UploadType.communityPolicing:
            store = useCommunityPolicingStore();
            break;
        case UploadType.nibrs:
            store = useNibrsStore();
            break;
        case UploadType.summary:
            store = useSummaryStore();
            break;
        case UploadType.useOfForce:
            store = useUofStore();
            break;
        case UploadType.narrative:
            store = useNarrativeStore();
            break;
        case UploadType.policeEmployee:
            store = usePoliceEmployeeStore();
            break;
        case UploadType.population:
            store = usePopulationStore();
            break;
    }
var details = ref({} as UploadedFileDetails);
var failedFileValidationMessages = ref([] as FailedFileDetails[]);
var isShowFilterEditor = ref(false);
var isValidationMessagesFilterEditorVisible = ref(false);
var hasAppliedFilters = ref(false);
var options = ref({
    totalItemCount: 0,
    itemsPerPage: 25,
    page: 1,
    sortBy: [],
    filterBy: [],            
    pagingMode: (props.noTotal?"noTotal":"withTotal")
} as BTableOptions);
var filterOptions = ref({
    filters: [],
} as BFilterOptions);
var showErrorDescriptionModal = ref(false);
var selectedErrorDescription = ref("");
var selectedErrorCode = ref("");
var selectedErrorType = ref("");
var selectedErrorBody = ref("");
var validationMessagesTableOptions = ref({
    totalItemCount: 0,
    itemsPerPage: 25,
    page: 1,
    sortBy: [],
    filterBy: [],            
    pagingMode: "noTotal"
} as BTableOptions);
var validationMessagesFilterOptions = ref({
    filters: [],
} as BFilterOptions);
var numberOfReturnedItems = ref(0);
var errorsAndWarningsFilterableFields = computed(():BFilterableField[] => {
    return store.getFilterableFieldsForErrorsAndWarnings(props.onlyHasOneOri, false, true) as BFilterableField[];
});

var columns = computed((): BTableColumn[] => {
    return store.getErrorsAndWarningsColumns(props.onlyHasOneOri, false, true);
});

const statisticsColumns = computed(() => {
    if (props.dataset == "population") {
        return [
            {
                key: "type",
                text: "",
                sortable: false,
                value: (item) => item.type,
                columnClass: ["text-center"],
                class: (item) => ["text-center"],
            },
            {
                key: "submitted",
                text: "Added",
                sortable: false,
                value: (item) => item.submitted,
                columnClass: ["text-center"],
                class: (item) => ["text-center"],
            },
            {
                key: "rejected",
                text: "Updated",
                sortable: false,
                value: (item) => item.rejected,
                columnClass: ["text-center"],
                class: (item) => ["text-center"],
            },
        ] as BTableColumn[];
    }
    return [
        {
            key: "type",
            text: "",
            sortable: false,
            value: (item) => item.type,
            columnClass: ["text-center"],
            class: (item) => ["text-center"],
        },
        {
            key: "submitted",
            text: "Submitted",
            sortable: false,
            value: (item) => item.submitted,
            columnClass: ["text-center"],
            class: (item) => ["text-center"],
        },
        {
            key: "rejected",
            text: "Rejected",
            sortable: false,
            value: (item) => item.rejected,
            columnClass: ["text-center"],
            class: (item) => ["text-center"],
        },
        {
            key: "rejectionRate",
            text: "Rejection Rate",
            sortable: false,
            value: (item) => item.rejectionRate,
            columnClass: ["text-center"],
            class: (item) => ["align-center"],
        },
    ] as BTableColumn[];
});

const statisticsTableOptions = computed(() => {
    return {
        totalItemCount: 0,
        itemsPerPage: 25,
        page: 1,
        sortBy: [],
        filterBy: [],
    } as BTableOptions;
});

const validationMessagesColumns = computed(() => {
    return store.getValidationMessagesColumns;
});

const filtersDescription = computed(() => {
    if (filterOptions == null) {
        return "";
    }
    return describeFilters(
        filterOptions.value.filters,
        errorsAndWarningsFilterableFields.value
    );
});


const showErrorsAndWarnings = computed(() => {
    return (
        details.value.status?.toLowerCase() !== "failed" &&
        details.value.status?.toLowerCase() !== "completed"
    );
});
 
var errorsAndWarnings = ref<UploadedFileWarningsAndErrors[]>(
    [] as UploadedFileWarningsAndErrors[]
);
fetchDetails();

function fetchDetails() {
    store.getRecordDetails(props.id)
        .then((response: AxiosResponse) => {
            details.value = response.data;
            let status = response.data.status.toLowerCase();
            if (status == "failed") {
                fetchValidationMessages();
            } else if (status != "completed" && status != "pending") {
                fetchErrorsAndWarnings();
            }
        });
}
function fetchValidationMessages() {
    let filters = [] as BFilter[];
    if (validationMessagesFilterOptions.value.filters != undefined) {
        filters = validationMessagesFilterOptions.value.filters;
    }

    store.getValidationMessagesForFile(
            props.id,
            validationMessagesTableOptions.value.page,
            validationMessagesTableOptions.value.itemsPerPage,
            filters,
            validationMessagesFilterableFields,
            validationMessagesTableOptions.value.sortBy
        )
        .then((response: AxiosResponse) => {
            failedFileValidationMessages.value = response.data.data;
            validationMessagesTableOptions.value.totalItemCount = response.data.total;
            numberOfReturnedItems.value = response.data.data.length;    
        });
}

function fetchErrorsAndWarnings() {
    let filters = [] as BFilter[];
    if (hasAppliedFilters) {
        filters = filterOptions.value.filters;
    }
    store.getErrorsAndWarningsForFile(props.id, filters, options.value, errorsAndWarningsFilterableFields.value, options.value.sortBy)
    .then((response:AxiosResponse) => {
        if(options.value.pagingMode == "noTotal" && response?.data?.data?.length > 0) {
                //When were hiding the total text,first button, and last button then we return itemsPerPage + 1 in our get data call. 
                //If the returned amount of rows is greater than itemsPerPage then enable the next button otherwise disable the next button to prevent an error
                errorsAndWarnings.value = response.data.data.slice(0,options.value.itemsPerPage);                    
            }
            else{
                errorsAndWarnings.value = response.data.data;
            }
            numberOfReturnedItems.value = response.data.data.length;            
            options.value.totalItemCount = response.data.total;
        })
        .catch((error:any) => {
            console.error(error?.response?.statusText);
        });

    return store.getErrorsAndWarningsForFile(
        props.id,
        filters,
        options.value,
        errorsAndWarningsFilterableFields.value,
        options.value.sortBy
    );
}

function resetFilters() {
    if (filterOptions.value != null) {
        filterOptions.value.filters = [];
        options.value.page = 1;
        fetchErrorsAndWarnings();
    }
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = false;
}

function applyFilters(newFilterOptions: BFilterOptions) {
    filterOptions.value = newFilterOptions;
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = newFilterOptions.filters.length > 0;

    options.value.page = 1;

    fetchErrorsAndWarnings();
}

function showFilterEditor(event: any) {
    event.preventDefault();

    isShowFilterEditor.value = true;
}

function handleDismiss() {
    isShowFilterEditor.value = false;
    isValidationMessagesFilterEditorVisible.value = false;
}

function handleOptionChange(newOptions: BTableOptions) {
    if (newOptions) {
        options.value = newOptions;
    }
    fetchErrorsAndWarnings();
}
//Start of Validation Messages methods
function resetValidationMessagesFilters() {
    if (validationMessagesFilterOptions.value != null) {
        validationMessagesFilterOptions.value.filters = [];

        fetchValidationMessages();
    }
    isValidationMessagesFilterEditorVisible.value = false;
}

function applyValidationMessagesFilters(filterOptions: BFilterOptions) {
    validationMessagesFilterOptions.value = filterOptions;
    handleDismiss();

    if (validationMessagesFilterOptions.value.filters.length > 0) {
        validationMessagesTableOptions.value.page = 1;
    }

    fetchValidationMessages();
}

function showValidationMessagesFilterEditor() {
    isValidationMessagesFilterEditorVisible.value = true;
}

function handleValidationMessagesOptionChange(newOptions: BTableOptions) {
    if (newOptions) {
        validationMessagesTableOptions.value = newOptions;
    }
}

//End of errors grid methods
function handleErrorDescriptionModalDismiss() {
    showErrorDescriptionModal.value = false;
}
function handleErrorCodeClick(item: any) {
    let errorCode = item["errorCode"];
    selectedErrorCode.value = "";
    selectedErrorDescription.value = "";
    selectedErrorBody.value = "No information available";

    if (
        errorCode != undefined &&
        store.errorDescriptions &&
        store.errorDescriptions.value
    ) {
        selectedErrorCode.value = errorCode;
        store.errorDescriptions.value.forEach((f) => {
            if (f.code == errorCode) {
                selectedErrorType.value = item["errorType"];
                selectedErrorDescription.value = f.help;

                var descriptionText = "";

                getHtmlContent(`help.aspx?e=${selectedErrorCode.value}`)
                .then(data => descriptionText = data)
                .catch(err => descriptionText = '')
                .finally(() => {
                    if (descriptionText != '') {
                        selectedErrorBody.value = descriptionText;
                    }
                    else if (selectedErrorDescription.value != '') {
                        selectedErrorBody.value = selectedErrorDescription.value ;
                    }
                    else {
                        selectedErrorBody.value = 'No information available';
                    }
                    showErrorDescriptionModal.value = true;
                    return;
                });
            }
        });
        showErrorDescriptionModal.value = true;
    }
}

function validationMessagesFiltersDescription(): string {
    if (validationMessagesFilterOptions.value == null) {
        return "";
    }
    return describeFilters(
        validationMessagesFilterOptions.value.filters,
        validationMessagesFilterableFields
    );
}

function generateLinkToEditor(item: UploadedFileWarningsAndErrors) {
    var url = props.editorLink;
    url = url.replace(
        "{{incidentnumber}}",
        encodeURIComponent(item["incidentNumber"])
    );
    url = url.replace("{{ori}}", encodeURIComponent(item.ori));

    return url;
}

function shouldHaveLinkToIE(item: UploadedFileWarningsAndErrors) {
    if (item["isZeroReport"]) {
        return false;
    }
    return true;
}

function handleErrorExport(fileType: string) {
    let filters = [] as any[];

    if (hasAppliedFilters) {
        filters = filterOptions.value.filters;
    }

    var encodedFilter = encodeURIComponent(
        serializeFilters(filters, errorsAndWarningsFilterableFields.value)
    );
    var encodedSort = encodeURIComponent(serializeSortBy(options.value.sortBy));

    window.open(
        `${props.exportUrl}${fileType}?filter=${encodedFilter}&sort=${encodedSort}`,
        "_blank"
    );
}

watch(validationMessagesTableOptions, (validationMessagesTableOptions) => {
    if (validationMessagesTableOptions) {
        fetchValidationMessages();
    }
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_unref(details) != undefined && _unref(details).fileName != undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.name) + " - ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(details).fileName), 1)
          ])
        ]),
        (_unref(details).errorCode != null && _unref(details).errorMessage != null && _unref(details).errorCode.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[9] || (_cache[9] = _createElementVNode("strong", null, "File Error: ", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(details).errorCode) + " - " + _toDisplayString(_unref(details).errorMessage), 1)
            ]))
          : (_unref(details).errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[10] || (_cache[10] = _createElementVNode("strong", null, "File Error: ", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(details).errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("dl", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("dt", null, [
            _createElementVNode("span", { class: "title-bold" }, "Uploaded by:")
          ], -1)),
          _createElementVNode("dd", null, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(details).createdBy), 1)
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("dt", null, [
            _createElementVNode("span", { class: "title-bold" }, "Uploaded on:")
          ], -1)),
          _createElementVNode("dd", null, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(details).createdOn), 1)
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("dt", null, [
            _createElementVNode("span", { class: "title-bold" }, "Processed on:")
          ], -1)),
          _createElementVNode("dd", null, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(details).processedOn), 1)
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("dt", null, [
            _createElementVNode("span", { class: "title-bold" }, "Status:")
          ], -1)),
          _createElementVNode("dd", null, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(details).statusLabel), 1),
            (_unref(details).status?.toLowerCase() != 'failed' && _unref(details).fileStatistics?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(BTable, {
                    items: _unref(details).fileStatistics,
                    columns: statisticsColumns.value,
                    caption: 'Error Rate Statistics',
                    value: statisticsTableOptions.value
                  }, {
                    "cell.rejectionRate": _withCtx(({ item, column }) => [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(item.rejectionRate), 1)
                    ]),
                    _: 1
                  }, 8, ["items", "columns", "value"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_unref(details).status?.toLowerCase() === 'failed' && _unref(validationMessagesTableOptions).totalItemCount > 0)
            ? (_openBlock(), _createElementBlock("dt", _hoisted_14, _cache[11] || (_cache[11] = [
                _createElementVNode("span", { class: "title-bold" }, "Errors:", -1)
              ])))
            : _createCommentVNode("", true),
          (_unref(details).status?.toLowerCase() === 'failed' && (_unref(validationMessagesTableOptions).totalItemCount > 0 || _unref(validationMessagesFilterOptions).filters.length > 0))
            ? (_openBlock(), _createElementBlock("dd", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(BFilterModal, {
                    isShowFilterEditor: _unref(isValidationMessagesFilterEditorVisible),
                    filterOptions: _unref(validationMessagesFilterOptions),
                    filterableFields: _unref(validationMessagesFilterableFields),
                    onFilterChanged: applyValidationMessagesFilters,
                    onDismissModal: handleDismiss
                  }, null, 8, ["isShowFilterEditor", "filterOptions", "filterableFields"]),
                  _createVNode(BTableHeader, {
                    value: _unref(validationMessagesTableOptions),
                    "header-slot-class": "b-header-slot w-100",
                    onOptionChange: handleValidationMessagesOptionChange,
                    style: {"max-width":"800px"},
                    "current-item-count": _unref(numberOfReturnedItems)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showValidationMessagesFilterEditor()), ["prevent"])),
                        class: "btn btn-primary"
                      }, _cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "bi bi-search pe-1" }, null, -1),
                        _createTextVNode(" Filter ", -1)
                      ])),
                      _renderSlot(_ctx.$slots, "header.toolbar"),
                      (_unref(validationMessagesFilterOptions).filters.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(validationMessagesFiltersDescription()), 1))
                        : _createCommentVNode("", true),
                      (_unref(validationMessagesFilterOptions).filters.length > 0)
                        ? _withDirectives((_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn-close",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (resetValidationMessagesFilters()))
                          }, null, 512)), [
                            [_directive_tooltip, 'Remove all currently applied filters.']
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    headerTopBar: _withCtx(() => [
                      (_unref(store).showWarningDetails)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(DropDown, {
                              label: "Error/Warning Details",
                              "item-count": 2,
                              "is-primary-button": false
                            }, {
                              item1: _withCtx(({}) => [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: `${_unref(store).errorDescriptionsDownloadUrl}csv`
                                }, "Download as .csv", 8, _hoisted_19)
                              ]),
                              item2: _withCtx(({}) => [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: `${_unref(store).errorDescriptionsDownloadUrl}xlsx`
                                }, "Download as .xlsx", 8, _hoisted_20)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 3
                  }, 8, ["value", "current-item-count"]),
                  _createVNode(BTable, {
                    items: _unref(failedFileValidationMessages),
                    columns: validationMessagesColumns.value,
                    caption: 'Validation Messages',
                    value: _unref(validationMessagesTableOptions),
                    "table-style": 'max-width: 800px;',
                    onOptionChange: handleValidationMessagesOptionChange
                  }, {
                    "cell.errorCode": _withCtx(({ item }) => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
                        onClick: _withModifiers(($event: any) => (handleErrorCodeClick(item)), ["prevent"])
                      }, _toDisplayString(item["errorCode"]), 9, _hoisted_21)
                    ]),
                    _: 1
                  }, 8, ["items", "columns", "value"]),
                  _createVNode(BTableHeader, {
                    value: _unref(validationMessagesTableOptions),
                    onOptionChange: handleValidationMessagesOptionChange,
                    "header-slot-class": "b-header-slot w-100",
                    style: {"max-width":"800px"},
                    "current-item-count": _unref(numberOfReturnedItems)
                  }, null, 8, ["value", "current-item-count"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(InformationModal, {
          title: _unref(selectedErrorCode),
          "show-modal": _unref(showErrorDescriptionModal),
          onDismiss: handleErrorDescriptionModalDismiss
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", { innerHTML: _unref(selectedErrorBody) }, null, 8, _hoisted_22)
          ]),
          _: 1
        }, 8, ["title", "show-modal"]),
        _withDirectives(_createElementVNode("div", _hoisted_23, [
          _cache[18] || (_cache[18] = _createElementVNode("h4", {
            id: "errorTitle",
            class: "title-bold position-relative",
            style: {"top":"45px"}
          }, "Errors and Warnings:", -1)),
          _createVNode(BFilterModal, {
            isShowFilterEditor: _unref(isShowFilterEditor),
            filterOptions: _unref(filterOptions),
            filterableFields: _unref(errorsAndWarningsFilterableFields),
            onFilterChanged: applyFilters,
            onDismissModal: handleDismiss
          }, null, 8, ["isShowFilterEditor", "filterOptions", "filterableFields"]),
          _createVNode(BTableHeader, {
            value: _unref(options),
            onOptionChange: _cache[6] || (_cache[6] = ($event: any) => (handleOptionChange($event))),
            "header-slot-class": "b-header-slot w-100",
            "current-item-count": _unref(numberOfReturnedItems)
          }, {
            default: _withCtx(() => [
              (_unref(errorsAndWarningsFilterableFields).length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showFilterEditor($event))),
                    class: "btn btn-primary filter-button-width"
                  }, _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "bi bi-search pe-1" }, null, -1),
                    _createTextVNode(" Filter ", -1)
                  ])))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "header.toolbar"),
              (_unref(hasAppliedFilters))
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(filtersDescription.value), 1))
                : _createCommentVNode("", true),
              (_unref(hasAppliedFilters))
                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn-close",
                    onClick: _cache[3] || (_cache[3] = (event) => resetFilters())
                  }, null, 512)), [
                    [_directive_tooltip, 'Remove all currently applied filters.']
                  ])
                : _createCommentVNode("", true)
            ]),
            headerTopBar: _withCtx(() => [
              (_unref(store).showWarningDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createVNode(DropDown, {
                      label: "Error/Warning Details",
                      "item-count": 2,
                      "is-primary-button": false
                    }, {
                      item1: _withCtx(({}) => [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: `${_unref(store).errorDescriptionsDownloadUrl}csv`
                        }, "Download as .csv", 8, _hoisted_26)
                      ]),
                      item2: _withCtx(({}) => [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: `${_unref(store).errorDescriptionsDownloadUrl}xlsx`
                        }, "Download as .xlsx", 8, _hoisted_27)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            pagingStart: _withCtx(() => [
              (_unref(store).showWarningDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(DropDown, {
                      label: "Export Data",
                      "item-count": 2,
                      "is-primary-button": true
                    }, {
                      item1: _withCtx(({ item }) => [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:void",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleErrorExport('csv')), ["prevent"]))
                        }, "Download as .csv")
                      ]),
                      item2: _withCtx(({ item }) => [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:void",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (handleErrorExport('xlsx')), ["prevent"]))
                        }, "Download as .xlsx")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["value", "current-item-count"]),
          _createVNode(BTable, {
            items: _unref(errorsAndWarnings),
            columns: _unref(columns),
            caption: 'List of errors and warnings',
            value: _unref(options),
            onOptionChange: _cache[7] || (_cache[7] = ($event: any) => (handleOptionChange($event)))
          }, {
            "cell.agency": _withCtx(({ item, column }) => [
              _createElementVNode("span", {
                innerHTML: item.agency
              }, null, 8, _hoisted_29)
            ]),
            "cell.incidentNumber": _withCtx(({ item, column }) => [
              (_ctx.enableLinkToEditor && shouldHaveLinkToIE(item))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
                    href: generateLinkToEditor(item)
                  }, _toDisplayString(item["incidentNumber"]), 9, _hoisted_30))
                : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item["incidentNumber"]), 1))
            ]),
            "cell.errorCode": _withCtx(({ item }) => [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
                onClick: _withModifiers(($event: any) => (handleErrorCodeClick(item)), ["prevent"])
              }, _toDisplayString(item["errorCode"]), 9, _hoisted_32)
            ]),
            _: 1
          }, 8, ["items", "columns", "value"]),
          _createVNode(BTableHeader, {
            value: _unref(options),
            onOptionChange: _cache[8] || (_cache[8] = ($event: any) => (handleOptionChange($event))),
            "header-slot-class": "b-header-slot w-100",
            "current-item-count": _unref(numberOfReturnedItems)
          }, null, 8, ["value", "current-item-count"])
        ], 512), [
          [_vShow, showErrorsAndWarnings.value]
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[19] || (_cache[19] = [
        _createElementVNode("div", { class: "header w-100 text-center" }, [
          _createElementVNode("h3", { class: "mx-auto" }, "Loading...")
        ], -1)
      ])))
}
}

})